// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1mok{border-radius:var(--ds-radius-large,8px)}\n._v5649spz{transition:box-shadow .5s ease}\n._v564fs5d{transition:opacity .5s ease}._16qs1aef{box-shadow:0 8px 9pt rgba(9,30,66,0),0 0 1px rgba(9,30,66,0)}\n._16qsie2t{box-shadow:var(--ds-shadow-overlay,0 8px 9pt rgba(9,30,66,.15),0 0 1px rgba(9,30,66,.31))}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._tzy4idpf{opacity:0}\n._tzy4kb7n{opacity:1}", ""]);
// Exports
module.exports = exports;
